import { LOCAL_STORAGE_STATE_TO_PAST_VISIT } from '../../utils/constants'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const onHandleLinkToVisit = ({ PatientId, VisitId }) => {
  const stateToPastVisit = { patientId: PatientId, visitId: VisitId }
  safeLocalStorage.set(LOCAL_STORAGE_STATE_TO_PAST_VISIT, JSON.stringify(stateToPastVisit))
}
